import type { SearchRequestsParams } from '@transreport/pauk-rrms-api'
import { addDays, format } from 'date-fns'
import { create } from 'zustand'

export type DashboardRequestsCategory = 'all' | 'arrival' | 'departure'

export type DashboardRequestsFilters = Omit<SearchRequestsParams, 'station_code'> & {
  category?: DashboardRequestsCategory
}

function getDefaultDashboardRequestsFilters(): DashboardRequestsFilters {
  const startDateTime = new Date()
  startDateTime.setHours(0, 0, 0, 0)

  const endDateTime = addDays(new Date(), 7)
  endDateTime.setHours(23, 59, 0, 0)

  const today = format(startDateTime, "yyyy-MM-dd'T'HH:mm")
  const oneWeekFromToday = format(endDateTime, "yyyy-MM-dd'T'HH:mm")
  return {
    query: '',
    date_from: today,
    date_to: oneWeekFromToday,
    category: 'all',
  }
}

interface DashboardRequestsState {
  filters: DashboardRequestsFilters

  setFilter: <K extends keyof DashboardRequestsFilters>(
    key: K,
    value: DashboardRequestsFilters[K]
  ) => void
  setFilters: (partial: Partial<DashboardRequestsFilters>) => void
  clearFilters: () => void
}

export const useDashboardRequestsStore = create<DashboardRequestsState>()((set) => ({
  filters: getDefaultDashboardRequestsFilters(),

  setFilter: (key, value) =>
    set((state) => ({
      filters: { ...state.filters, [key]: value },
    })),

  setFilters: (partial) =>
    set((state) => ({
      filters: { ...state.filters, ...partial },
    })),

  clearFilters: () =>
    set({
      filters: getDefaultDashboardRequestsFilters(),
    }),
}))
